import type { ApplePayPaymentData } from '@ctct/infrastructure-layer';

import { EventBus } from '../../helpers';

type OverdueSummaryEvents = {
  overduePaymentDataUpdated: [paymentData: Omit<ApplePayPaymentData, 'label'>];
};

class OverdueSummaryEventBus extends EventBus<OverdueSummaryEvents> {}

export const overdueSummaryEventBus = new OverdueSummaryEventBus();
